/** Keys under `pro.onboarding_agent.*` — published copy should use the product name "Onboarding Agent". */
export const ONBOARDING_AGENT_TRIGGER_ARIA_LABEL = "pro.onboarding_agent.trigger.aria_label";
export const ONBOARDING_AGENT_TRIGGER_TOOLTIP = "pro.onboarding_agent.trigger.tooltip";

export const ONBOARDING_AGENT_PANEL_TITLE = "pro.onboarding_agent.panel.title";
export const ONBOARDING_AGENT_PANEL_CLOSE_ARIA = "pro.onboarding_agent.panel.close_aria";
export const ONBOARDING_AGENT_PANEL_EXPAND_HEIGHT_ARIA = "pro.onboarding_agent.panel.expand_height_aria";
export const ONBOARDING_AGENT_PANEL_COLLAPSE_HEIGHT_ARIA = "pro.onboarding_agent.panel.collapse_height_aria";
export const ONBOARDING_AGENT_PANEL_EXPAND_TOOLTIP = "pro.onboarding_agent.panel.expand_tooltip";
export const ONBOARDING_AGENT_PANEL_MINIMIZE_TOOLTIP = "pro.onboarding_agent.panel.minimize_tooltip";
export const ONBOARDING_AGENT_PANEL_NEW_CHAT_TOOLTIP = "pro.onboarding_agent.panel.new_chat_tooltip";
export const ONBOARDING_AGENT_PANEL_NEW_CHAT_ARIA = "pro.onboarding_agent.panel.new_chat_aria";
export const ONBOARDING_AGENT_PANEL_CLOSE_TOOLTIP = "pro.onboarding_agent.panel.close_tooltip";

export const ONBOARDING_AGENT_INPUT_PLACEHOLDER = "pro.onboarding_agent.input.placeholder";
export const ONBOARDING_AGENT_INPUT_SEND_ARIA = "pro.onboarding_agent.input.send_aria";
export const ONBOARDING_AGENT_INPUT_STOP_ARIA = "pro.onboarding_agent.input.stop_aria";

export const ONBOARDING_AGENT_LOADING_TEXT = "pro.onboarding_agent.loading.text";

export const ONBOARDING_AGENT_MESSAGE_EXPLORE_NEXT = "pro.onboarding_agent.message.explore_next";
export const ONBOARDING_AGENT_DIRECT_LINK_MESSAGE = "pro.onboarding_agent.direct_link.message";
export const ONBOARDING_AGENT_DIRECT_LINK_WEBSITE_PERFORMANCE_LABEL =
    "pro.onboarding_agent.direct_link.website_performance_label";
export const ONBOARDING_AGENT_DIRECT_LINK_WEBSITE_CONTENT_LABEL =
    "pro.onboarding_agent.direct_link.website_content_label";
export const ONBOARDING_AGENT_MESSAGE_SHOW_MORE = "pro.onboarding_agent.message.show_more";
export const ONBOARDING_AGENT_MESSAGE_SHOW_LESS = "pro.onboarding_agent.message.show_less";
export const ONBOARDING_AGENT_MESSAGE_QUICK_ACTIONS = "pro.onboarding_agent.message.quick_actions";
export const ONBOARDING_AGENT_MESSAGE_FOLLOW_UP_QUESTIONS = "pro.onboarding_agent.message.follow_up_questions";
export const ONBOARDING_AGENT_MESSAGE_SUGGESTED_ACTIONS = "pro.onboarding_agent.message.suggested_actions";

export const ONBOARDING_AGENT_GREETING_HEADLINE_BEFORE = "pro.onboarding_agent.greeting.headline_before";
export const ONBOARDING_AGENT_GREETING_HEADLINE_AFTER = "pro.onboarding_agent.greeting.headline_after";
export const ONBOARDING_AGENT_GREETING_HEADLINE_FALLBACK = "pro.onboarding_agent.greeting.headline_fallback";
export const ONBOARDING_AGENT_GREETING_BODY = "pro.onboarding_agent.greeting.body";
export const ONBOARDING_AGENT_GREETING_FIRST_HEADLINE_AFTER = "pro.onboarding_agent.greeting.first_headline_after";
export const ONBOARDING_AGENT_GREETING_FIRST_HEADLINE_FALLBACK =
    "pro.onboarding_agent.greeting.first_headline_fallback";
export const ONBOARDING_AGENT_GREETING_FIRST_BODY = "pro.onboarding_agent.greeting.first_body";

export const ONBOARDING_AGENT_ERROR_RETRY = "pro.onboarding_agent.error.retry";
export const ONBOARDING_AGENT_ERROR_TITLE = "pro.onboarding_agent.error.title";
export const ONBOARDING_AGENT_ERROR_DESCRIPTION = "pro.onboarding_agent.error.description";

export const ONBOARDING_AGENT_FEEDBACK_COPY = "activation.home.insights.feedback.copy";
export const ONBOARDING_AGENT_FEEDBACK_COPIED = "activation.home.insights.feedback.copied";
export const ONBOARDING_AGENT_FEEDBACK_COPY_FAILED = "activation.home.insights.feedback.copy_failed";
export const ONBOARDING_AGENT_FEEDBACK_THUMBS_UP = "activation.home.insights.feedback.thumbs_up";
export const ONBOARDING_AGENT_FEEDBACK_THUMBS_DOWN = "activation.home.insights.feedback.thumbs_down";

export const ONBOARDING_AGENT_FEEDBACK_MODAL_TITLE = "activation.home.insights.feedback.modal_title";
export const ONBOARDING_AGENT_FEEDBACK_MODAL_PLACEHOLDER = "activation.home.insights.feedback.modal_placeholder";
export const ONBOARDING_AGENT_FEEDBACK_MODAL_CANCEL = "activation.home.insights.feedback.modal_cancel";
export const ONBOARDING_AGENT_FEEDBACK_MODAL_SUBMIT = "activation.home.insights.feedback.modal_submit";

export const ONBOARDING_AGENT_NUDGE_GREETING_TITLE = "pro.onboarding_agent.nudge.greeting_title";
export const ONBOARDING_AGENT_NUDGE_GREETING_FALLBACK = "pro.onboarding_agent.nudge.greeting_fallback";
export const ONBOARDING_AGENT_NUDGE_INPUT_PLACEHOLDER = "pro.onboarding_agent.nudge.input_placeholder";
export const ONBOARDING_AGENT_NUDGE_DISMISS_ARIA = "pro.onboarding_agent.nudge.dismiss_aria";
